export default __webpack_public_path__ + "static/media/gh.25994121.jpg";